import { render } from "./AudioPage.vue?vue&type=template&id=8be334e8"
import script from "./AudioPage.vue?vue&type=script&lang=js"
export * from "./AudioPage.vue?vue&type=script&lang=js"

import "./AudioPage.vue?vue&type=style&index=0&id=8be334e8&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__